module.exports = __webpack_public_path__ + "static/media/instagram_pos_icon.ae2082fd.svg";